export default "__VITE_ASSET__CSEf6o5Q__"